import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { Table } from "@opensea/ui-kit";
import { CreateOfferFlowTableFragment } from "./CreateOfferFlowTable.fragment";
import { CreateOfferFlowTableHeader } from "./CreateOfferFlowTableHeader";
import { CreateOfferFlowTableRow, CreateOfferFlowTableRowSkeleton } from "./CreateOfferFlowTableRow";
export const CreateOfferFlowTable = t0 => {
  const $ = _c(13);
  const {
    items: itemKeys,
    isReview
  } = t0;
  let t1;
  if ($[0] !== itemKeys) {
    t1 = itemKeys.map(_temp);
    $[0] = itemKeys;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const items = t1;
  let t2;
  if ($[2] !== isReview || $[3] !== items.length) {
    t2 = <CreateOfferFlowTableHeader isReview={isReview} numItems={items.length} />;
    $[2] = isReview;
    $[3] = items.length;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== isReview) {
    t3 = {
      isReview
    };
    $[5] = isReview;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== items || $[8] !== t3) {
    t4 = <Table className="shrink-0" context={t3} itemKey={_temp2} items={items} renderRow={CreateOfferFlowTableRow} size="md" />;
    $[7] = items;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t2 || $[11] !== t4) {
    t5 = <>{t2}{t4}</>;
    $[10] = t2;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};
export const CreateOfferFlowTableSkeleton = t0 => {
  const $ = _c(12);
  const {
    count
  } = t0;
  let t1;
  if ($[0] !== count) {
    t1 = <CreateOfferFlowTableHeader isReview={false} numItems={count} />;
    $[0] = count;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== count) {
    t2 = {
      count
    };
    $[2] = count;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== count) {
    t3 = new Array(count).fill(0);
    $[4] = count;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <Table className="shrink-0" context={t2} itemKey={_temp3} items={t3} renderRow={CreateOfferFlowTableRowSkeleton} size="md" />;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t1 || $[10] !== t4) {
    t5 = <>{t1}{t4}</>;
    $[9] = t1;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};
function _temp(i) {
  return readFragment(CreateOfferFlowTableFragment, i);
}
function _temp2(item) {
  return item?.id;
}
function _temp3(_, index) {
  return index;
}